import { useEffect, useRef } from 'react';
import { useState } from 'react';
import profileApi from '../../apis/profile-api';
import Loading from '../../components/Loading/Loading';
import './Profile.css';
import GlobalStore from '../../stores/global-store';

const initialValues = {
  bankName: '',
  bankAccountNo: '',
  bankAccountName: '',
  bankAccountBranch: '',
  frontSide: '',
  backSide: '',
  dateIssued: '',
  placeIssued: '',
  taxCode: '',
  idCode: '',
  phone: '',
  address: ''
};

const listBanks = [
  { label: 'NH NN&PT Nông thôn Việt Nam', name: 'Agribank' },
  { label: 'NH TNHH MTV Dầu khí toàn cầu', name: 'OceanBank' },
  { label: 'NH TNHH MTV Đại Dương', name: 'GPBank' },
  { label: 'NH TNHH MTV Xây dựng', name: 'CB' },
  { label: 'NH TMCP Công thương Việt Nam', name: 'VietinBank' },
  { label: 'NH TMCP Đầu tư và Phát triển Việt Nam', name: 'BIDV' },
  { label: 'NH TMCP Ngoại Thương Việt Nam', name: 'Vietcombank' },
  { label: 'NH TMCP Á Châu', name: 'ACB' },
  { label: 'NH TMCP An Bình', name: 'ABBANK' },
  { label: 'NH TMCP Bản Việt', name: 'Viet Capital Bank' },
  { label: 'NH TMCP Bảo Việt', name: 'BAOVIET Bank' },
  { label: 'NH TMCP Bắc Á', name: 'Bac A Bank' },
  { label: 'NH TMCP Bưu điện Liên Việt', name: 'LienVietPostBank' },
  { label: 'NH TMCP Đại Chúng Việt Nam', name: 'PVcomBank' },
  { label: 'NH TMCP Đông Á', name: 'DongA Bank' },
  { label: 'NH TMCP Đông Nam Á', name: 'SeABank' },
  { label: 'NH TMCP Hàng Hải', name: 'MSB' },
  { label: 'NH TMCP Kiên Long', name: 'Kienlongbank' },
  { label: 'NH TMCP Kỹ Thương', name: 'Techcombank' },
  { label: 'NH TMCP Nam Á', name: 'Nam A Bank' },
  { label: 'NH TMCP Phương Đông', name: 'OCB' },
  { label: 'NH TMCP Quân Đội', name: 'MB' },
  { label: 'NH TMCP Quốc Tế', name: 'VIB' },
  { label: 'NH TMCP Quốc dân', name: 'NCB' },
  { label: 'NH TMCP Sài Gòn', name: 'SCB' },
  { label: 'NH TMCP Sài Gòn Công Thương', name: 'SAIGONBANK' },
  { label: 'NH TMCP Sài Gòn – Hà Nội', name: 'SHB' },
  { label: 'NH TMCP Sài Gòn Thương Tín', name: 'Sacombank' },
  { label: 'NH TMCP Tiên Phong', name: 'TPBank' },
  { label: 'NH TMCP Việt Á', name: 'VietABank' },
  { label: 'NH TMCP Việt Nam Thịnh Vượng', name: 'VPBank' },
  { label: 'NH TMCP Việt Nam Thương Tín', name: 'Vietbank' },
  { label: 'NH TMCP Xăng dầu', name: 'Petrolimex PG Bank' },
  { label: 'NH TMCP Xuất Nhập Khẩu', name: 'Eximbank' },
  { label: 'NH TMCP Phát triển Thành phố Hồ Chí Minh', name: 'HDBank' },
  { label: 'NH Chính sách xã hội Việt Nam', name: 'VBSP' },
  { label: 'NH Phát triển Việt Nam', name: 'VDB' },
  { label: 'NH TNHH Indovina', name: 'IVB' },
  { label: 'NH Liên doanh Việt Nga', name: 'VRB' },
  { label: 'NH Hợp tác xã Việt Nam', name: 'Co-opBank' },
  { label: 'NH TNHH MTV ANZ Việt Nam', name: 'ANZVL' },
  { label: 'NH TNHH MTV Hong Leong Việt Nam', name: 'HLBVN' },
  { label: 'NH TNHH MTV HSBC Việt Nam', name: 'HSBC' },
  { label: 'NH TNHH MTV Shinhan Việt Nam', name: 'SHBVN' },
  { label: 'NH TNHH MTV Standard Chartered Việt Nam', name: 'SCBVL' },
  { label: 'NH TNHH MTV Public Bank Việt Nam', name: 'PBVN' },
  { label: 'NH TNHH MTV CIMB Việt Nam', name: 'CIMB' },
  { label: 'NH TNHH MTV Woori Việt Nam', name: 'Woori' }
];

function Profile() {
  const { affID } = GlobalStore.useContainer();
  const [isFrontUloading, setIsFrontUploading] = useState(false);
  const [isBackUloading, setIsBackUploading] = useState(false);
  const [profile, setProfile] = useState(initialValues);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
  const frontSideRef = useRef();
  const backSideRef = useRef();

  useEffect(() => {
    async function getAffiliate() {
      const { data } = await profileApi.getAffiliateById(affID);
      if (data) {
        setProfile({
          bankName: data.bank_name,
          bankAccountNo: data.bank_account_no,
          bankAccountName: data.bank_account_name,
          bankAccountBranch: data.bank_account_branch,
          frontSide: data.id_image_1,
          backSide: data.id_image_2,
          dateIssued: data.date_issued,
          placeIssued: data.place_issued,
          taxCode: data.tax_code,
          idCode: data.id_code,
          phone: data.phone,
          address: data.shipping_street
        });
      } else {
        alert('Máy chủ đang bận.');
      }
    }

    getAffiliate();
  }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    const identifer = e.target.getAttribute('id');
    if (identifer === 'front-side') {
      setIsFrontUploading(true);
    } else {
      setIsBackUploading(true);
    }

    try {
      const { data } = await profileApi.uploadPhoto(file, affID);
      if (data.status) {
        if (identifer === 'front-side') {
          setProfile({
            ...profile,
            frontSide: data.data.url
          });
          setIsFrontUploading(false);
        } else {
          setProfile({
            ...profile,
            backSide: data.data.url
          });
          setIsBackUploading(false);
        }
      } else {
        alert('Không thể upload file. ' + data.data);
        e.target.value = null;
        setIsFrontUploading(false);
        setIsBackUploading(false);
      }
    } catch (e) {
      setIsFrontUploading(false);
      setIsBackUploading(false);
      e.target.value = null;
      throw new Error(e);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const isValid = validateForm(event);
    if (isValid) {
      setIsSubmitting(true);
      const payload = {
        tax_code: profile.taxCode,
        id_code: profile.idCode,
        id_image_1: profile.frontSide,
        id_image_2: profile.backSide,
        date_issued: profile.dateIssued,
        place_issued: profile.placeIssued,
        bank_name: profile.bankName,
        bank_account_no: profile.bankAccountNo,
        bank_account_name: profile.bankAccountName,
        bank_account_branch: profile.bankAccountBranch,
        phone: profile.phone,
        shipping_street: profile.address,
      }
      const { data } = await profileApi.updateAffiliateProfile(payload, affID);
      if (data?.profile?.affiliate_id) {
        setIsSubmitting(false);
        setStatus({
          code: 202,
          msg: 'Cập nhật thành công'
        });
        setTimeout(() => {
          window.location.href = '/affiliate-area-dashboard';
        }, 500);
      } else {
        setStatus({
          code: 500,
          msg: 'Cập nhật không thành công. Xin vui lòng thử lại!'
        });
        setIsSubmitting(false);
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setProfile({
      ...profile,
      [name]: value
    });
    setStatus(null);
    event.target.classList.remove('is-invalid');
  };

  const validateForm = (e) => {
    if (!validateNumber(profile.taxCode)) {
      e.target.taxCode.classList.add('is-invalid');
      e.target.taxCode.focus();
      return false;
    } else if (!validateNumber(profile.idCode)) {
      e.target.idCode.classList.add('is-invalid');
      e.target.idCode.focus();
      return false;
    } else if (!validatePhoneNumber(profile.phone)) {
      e.target.phone.classList.add('is-invalid');
      e.target.phone.focus();
      return false;
    } else if (!profile.frontSide || !profile.backSide) {
      alert('Vui lòng chọn hình CMND/Passport');
      return false;
    }
    return true;
  };

  const validatePhoneNumber = (phone) => {
    const reg = /(84|0)+([0-9]{9})\b/;
    return reg.test(String(phone).toLowerCase());
  };

  const validateNumber = (number) => {
    const reg = /^\d+$/;
    return reg.test(number);
  };

  const validateRequired = (e) => {
    if (e.target.value === '') {
      e.target.classList.add('is-invalid');
      e.target.focus();
    }
  }

  return (
    <div className="page-profile container-fluid pb-4">
      <h2>Cập nhật profile</h2>
      <p className="text-muted mb-5">Vui lòng điền thông tin chính xác để ELSA có thể tiến hành thanh toán cho bạn</p>
      <form id="update-profile" encType="multipart/form-data" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-4">
            <h3 className="group-title">Phương thức thanh toán</h3>
          </div>
          <div className="col-md-8">
            <div className="card card-profile">
              <div className="mb-3">
                <label htmlFor="bank_no" className="form-label">Tên ngân hàng</label>
                <select className="form-control" value={profile.bankName} name="bankName" onChange={handleChange} required>
                  <option value="">Vui lòng chọn...</option>
                  {listBanks.map((bank, index) => <option key={index} value={`${bank.label} - ${bank.name}`}>{`${bank.label} - ${bank.name}`}</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="bank_no" className="form-label">Số tài khoản</label>
                <input type="text" className="form-control" value={profile.bankAccountNo} name="bankAccountNo" onChange={handleChange} onBlur={validateRequired} required />
                <div class="invalid-feedback">Thông tin bắt buộc!</div>
              </div>
              <div className="mb-3">
                <label htmlFor="bank_account_name" className="form-label">Tên chủ tài khoản</label>
                <input type="text" className="form-control" value={profile.bankAccountName} name="bankAccountName" onChange={handleChange} onBlur={validateRequired} required />
                <div class="invalid-feedback">Thông tin bắt buộc!</div>
              </div>
              <div className="mb-3">
                <label htmlFor="bank_branch" className="form-label">Chi nhánh ngân hàng</label>
                <input type="text" className="form-control" value={profile.bankAccountBranch} name="bankAccountBranch" onChange={handleChange} onBlur={validateRequired} required />
                <div class="invalid-feedback">Thông tin bắt buộc!</div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row mb-4">
          <div className="col-md-4">
            <h3 className="group-title">Thông tin cá nhân</h3>
          </div>
          <div className="col-md-8">
            <div className="card card-profile">
              <div className="mb-3">
                <label htmlFor="tax" className="form-label">Mã số thuế</label>
                <input type="text" className="form-control" value={profile.taxCode} name="taxCode" onChange={handleChange} onBlur={(e) => {
                  if (!validateNumber(e.target.value)) {
                    e.target.classList.add('is-invalid');
                    e.target.focus();
                  }
                }} required />
                <div class="invalid-feedback">Mã số thuế không hợp lệ!</div>
              </div>
              <div className="mb-3">
                <label htmlFor="id" className="form-label">CMND/Passport</label>
                <input type="text" className="form-control" value={profile.idCode} name="idCode" onChange={handleChange} onBlur={(e) => {
                  if (!validateNumber(e.target.value)) {
                    e.target.classList.add('is-invalid');
                    e.target.focus();
                  }
                }} required />
                <div class="invalid-feedback">CMND/Passport không hợp lệ!</div>
              </div>
              <div className="mb-3">
                <label htmlFor="file" className="form-label">Ảnh 2 mặt của CMND/Passport</label>
                <div className="upload-area">
                  <input type="file" accept="image/*" ref={frontSideRef} id="front-side" onChange={handleUpload} />
                  <input type="file" accept="image/*" ref={backSideRef} id="back-side" onChange={handleUpload} />
                  <div className="photos">
                    <div className="row">
                      <div className="col-6">
                        <p className="text-instruction text-uppercase">Mặt trước</p>
                        {!profile.frontSide && (
                          <label htmlFor="front-side" className="wrap-photo btn-upload">
                            <span className="inner-photo" style={{ opacity: isFrontUloading ? '0.2' : 1 }}><span className="label-upload"><svg className="icon-upload" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,10a1,1,0,0,0-1,1v3.38L16.52,12.9a2.79,2.79,0,0,0-3.93,0l-.7.71L9.41,11.12a2.79,2.79,0,0,0-3.93,0L4,12.61V7A1,1,0,0,1,5,6h8a1,1,0,0,0,0-2H5A3,3,0,0,0,2,7V19.22A2.79,2.79,0,0,0,4.78,22H17.22a2.88,2.88,0,0,0,.8-.12h0a2.74,2.74,0,0,0,2-2.65V11A1,1,0,0,0,19,10ZM5,20a1,1,0,0,1-1-1V15.43l2.89-2.89a.78.78,0,0,1,1.1,0L15.46,20Zm13-1a1,1,0,0,1-.18.54L13.3,15l.71-.7a.77.77,0,0,1,1.1,0L18,17.21ZM21,4H20V3a1,1,0,0,0-2,0V4H17a1,1,0,0,0,0,2h1V7a1,1,0,0,0,2,0V6h1a1,1,0,0,0,0-2Z" /></svg> Tải lên</span></span>
                            {isFrontUloading && <Loading color="#3b8dff" />}
                          </label>
                        )}
                        {profile.frontSide && (
                          <div className="wrap-photo">
                            <span className="inner-photo"><img src={profile.frontSide} alt="" className="id-image" /></span>
                            <span className="remove-photo" onClick={() => {
                              setProfile({ ...profile, frontSide: '' });
                              frontSideRef.current.value = '';
                            }}>&times;</span>
                          </div>
                        )}
                      </div>
                      <div className="col-6">
                        <p className="text-instruction text-uppercase">Mặt sau</p>
                        {!profile.backSide && (
                          <label htmlFor="back-side" className="wrap-photo btn-upload">
                            <span className="inner-photo" style={{ opacity: isBackUloading ? '0.2' : '' }}><span className="label-upload"><svg className="icon-upload" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,10a1,1,0,0,0-1,1v3.38L16.52,12.9a2.79,2.79,0,0,0-3.93,0l-.7.71L9.41,11.12a2.79,2.79,0,0,0-3.93,0L4,12.61V7A1,1,0,0,1,5,6h8a1,1,0,0,0,0-2H5A3,3,0,0,0,2,7V19.22A2.79,2.79,0,0,0,4.78,22H17.22a2.88,2.88,0,0,0,.8-.12h0a2.74,2.74,0,0,0,2-2.65V11A1,1,0,0,0,19,10ZM5,20a1,1,0,0,1-1-1V15.43l2.89-2.89a.78.78,0,0,1,1.1,0L15.46,20Zm13-1a1,1,0,0,1-.18.54L13.3,15l.71-.7a.77.77,0,0,1,1.1,0L18,17.21ZM21,4H20V3a1,1,0,0,0-2,0V4H17a1,1,0,0,0,0,2h1V7a1,1,0,0,0,2,0V6h1a1,1,0,0,0,0-2Z" /></svg> Tải lên</span></span>
                            {isBackUloading && <Loading color="#3b8dff" />}
                          </label>
                        )}
                        {profile.backSide && (
                          <div className="wrap-photo">
                            <span className="inner-photo"><img src={profile.backSide} alt="" className="id-image" /></span>
                            <span className="remove-photo" onClick={(e) => {
                              setProfile({ ...profile, backSide: '' });
                              backSideRef.current.value = '';
                            }}>&times;</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <input type="hidden" name="frontSide" value={profile.frontSide} onChange={handleChange} />
                <input type="hidden" name="backSide" value={profile.backSide} onChange={handleChange} />
              </div>
              <div className="mb-3">
                <label htmlFor="date" className="form-label">Ngày cấp CMND/Passport</label>
                <input type="date" name="dateIssued" value={profile.dateIssued} className="form-control w-auto" onChange={handleChange} required />
              </div>
              <div className="mb-3">
                <label htmlFor="place" className="form-label">Nơi cấp</label>
                <input type="text" className="form-control" value={profile.placeIssued} name="placeIssued" onChange={handleChange} onBlur={validateRequired} required />
                <div class="invalid-feedback">Thông tin bắt buộc!</div>
              </div>
              <div className="mb-3">
                <label htmlFor="phone" className="form-label">Phone</label>
                <input type="text" className="form-control" value={profile.phone} name="phone" onChange={handleChange} onBlur={(e) => {
                  if (!validatePhoneNumber(e.target.value)) {
                    e.target.classList.add('is-invalid');
                    e.target.focus();
                  }
                }} required />
                <div class="invalid-feedback">Số điện thoại không hợp lệ!</div>
              </div>
              <div className="mb-3">
                <label htmlFor="address" className="form-label">Địa chỉ</label>
                <input type="text" className="form-control" value={profile.address} name="address" onChange={handleChange} onBlur={validateRequired} required />
                <div class="invalid-feedback">Thông tin bắt buộc!</div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center">
          <button type="submit" className="common-btn text-uppercase font-weight-bold" disabled={isSubmitting}>Cập nhật</button>
          {status && <div className={'mt-2 ' + (status.code === 202 ? 'text-success' : 'text-danger')}>{status.msg}</div>}
        </div>
      </form>
    </div>
  )
}

export default Profile;
